/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/more_medium'
export default icon
